<template lang="pug">
  .component-intervention-request-form
    .row
      .column
        //template(v-if="!subRequest" )
          label Link to request
          selectize-intervention-request(:selected-value="localValue.linked_intervention_request_id", @optionSelected="setVehicle", @optionRemoved="unSetVehicle")
        template
          label Status
            select(v-model="localValue.status")
              option(v-for="status in ['NEW', 'ASSIGNED', 'IN_PROGRESS', 'COMPLETED', 'REFUSED']" ) {{status}}
        selectize-maintenance-driver(v-model="localValue.maintenance_driver_id", value-field="id" :selectedValue="localValue.maintenance_driver_id", v-if="!localValue.has_linked_requests")
        template
          label Start
          date-picker(format="yyyy-mm-dd hh:ii:ss", pick-time, v-model="localValue.start_at", :initial-date="localValue.start_at")
          label Expiry
          date-picker(format="yyyy-mm-dd hh:ii:ss", pick-time, v-model="localValue.expiry", :initial-date="localValue.expiry")
      .column
        template(v-if="!edit" )
          // creates a reservation
          label Disable for booking
            input-switch(v-model="localValue.create_reservation", )
        //template(v-if="localValue.linked_intervention_request_id === null && !edit" )
          label Disable for booking
            input-switch(v-model="localValue.disable_vehicle_slot", )
        selectize-vehicle(v-model="localValue.vehicle_id", value-field="id" :selectedValue="localValue.vehicle_id", v-if="localValue.hasOwnProperty('vehicle_id') && !subRequest", :disabled="localValue.linked_intervention_request_id !== null")

        label Priority
          select(v-model="localValue.priority")
            option(value="1") Minor
            option(value="2") Medium
            option(value="3") Major
          label Type
            template(v-if="edit")
              select(v-model="localValue.type")
                option(value="CLEANING") Cleaning
                option(value="ROUTINE") Routine
                option(value="PREPARATION") Preparation
                option(value="CHECK_OUT") Check-out
                option(value="REPOSITIONING") Repositioning
                option(value="ACCIDENT") Accident
                option(value="EXTERIOR_REPAIR") Exterior repair
                option(value="RECHARGE") Recharge
                option(value="LOW_BATTERY") Low Battery
            template(v-else v-for="type in ['CLEANING','ROUTINE','PREPARATION','CHECK_OUT','REPOSITIONING','ACCIDENT','EXTERIOR_REPAIR','RECHARGE','LOW_BATTERY']")
              label {{type}} &nbsp;
                input(type="checkbox", v-model="localValue.type", :value="type")

    .row
      .column
        label Description
        textarea(v-model="localValue.description", rows="10")

</template>

<script>
import BaseForm from './BaseForm.vue';
import SelectizeVehicle from "../ui/lists/selectize/SelectizeVehicle.vue";
import DatePicker from "../DatePicker.vue";
import SelectizeInterventionRequest from "../ui/lists/selectize/SelectizeInterventionRequest.vue";
import SelectizeMaintenanceDriver from "../ui/lists/selectize/SelectizeMaintenanceDriver.vue";
import InputSwitch from "../ui/InputSwitch.vue";

export default {
  name: "InterventionRequestForm",
  extends: BaseForm,
  components: {
    InputSwitch,
    SelectizeMaintenanceDriver, SelectizeInterventionRequest, DatePicker, SelectizeVehicle, BaseForm
  },
  data() {
    return {}
  },
  created() {
  },
  methods: {
    setVehicle(obj) {
      this.localValue.linked_intervention_request_id = obj.id
      this.localValue.vehicle_id = obj.vehicle.id
      this.$emit('input', this.localValue)
    },
    unSetVehicle() {
      this.localValue.linked_intervention_request_id = null
      this.localValue.vehicle_id = null
      this.$emit('input', this.localValue)
    }
  },
  props: {
    subRequest: {
      default: false
    },
    edit: {
      default: false
    }
  }
};
</script>



// WEBPACK FOOTER //
// InterventionRequestForm.vue?205a76c6